import {
  GET_LAB_FAIL,
  GET_LAB_SUCCESS,
  GET_LABS_FAIL,
  GET_LABS_SUCCESS,
  ADD_LAB_SUCCESS,
  ADD_LAB_FAIL,
  UPDATE_LAB_SUCCESS,
  UPDATE_LAB_FAIL,
  DELETE_LAB_SUCCESS,
  DELETE_LAB_FAIL,  
  SET_STATE_LAB
} from "./actionTypes";

const INIT_STATE = {
  labs: [],
  lab: {},
  error: {},
  loading: false,
  total: 0,
  currentPage: 0,
};

const labs = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_LABS_SUCCESS:
      return {
        ...state,
        labs: action.payload.labs,
        total: action.payload.total,
        currentPage: action.payload.currentPage,
      };

    case SET_STATE_LAB:
      return { ...state, loading: action.payload }

    case GET_LABS_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case ADD_LAB_SUCCESS:
      return {
        ...state,
        labs: [...state.labs, action.payload],
      };

    case ADD_LAB_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case UPDATE_LAB_SUCCESS:
      return {
        ...state,
        labs: state.labs.map(lab =>
          lab.id.toString() === action.payload.id.toString()
            ? { ...action.payload, lab }
            : lab
        ),
      };

    case UPDATE_LAB_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case DELETE_LAB_SUCCESS:
      return {
        ...state,
        labs: state.labs.filter(
          lab => lab.id.toString() !== action.id.toString()
        ),
      };

    case DELETE_LAB_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case GET_LAB_SUCCESS:
      return {
        ...state,
        lab: action.payload,
      };

    case GET_LAB_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default labs;
